"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GKButton = void 0;
var React = __importStar(require("react"));
var reactstrap_1 = require("reactstrap");
var clsx_1 = __importDefault(require("clsx"));
var common_1 = require("../../common");
var components_1 = require("../../components");
var react_router_dom_1 = require("react-router-dom");
require("./GKButton.css");
/**
 * Button component based on Reactstrap Button, provides correct styling for text-button
 * and icon-button scenarios in a variety of contexts. Note that color defaults to primary,
 * and outline will default to true if no color is specified.
 *
 * @remarks
 * Docs for underlying Button: https://reactstrap.github.io/components/buttons/
 */
var GKButton = /** @class */ (function (_super) {
    __extends(GKButton, _super);
    function GKButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.buttonRef = _this.props.innerRef || React.createRef();
        _this.focus = function () { var _a; return (_a = _this.buttonRef.current) === null || _a === void 0 ? void 0 : _a.focus(); };
        return _this;
    }
    GKButton.prototype.render = function () {
        var _a = (0, common_1.mapDefaultProps)(this.props, {
            _gkComponentName: "gk-button",
            className: (0, clsx_1.default)({
                "gk-icon-button": this.props.icon,
                "btn-icon": this.props.icon && !this.props.children,
                "btn-icon-right": this.props.children &&
                    this.props.icon &&
                    this.props.iconPosition === "after",
                "btn-icon-left": this.props.children &&
                    this.props.icon &&
                    this.props.iconPosition !== "after",
                disabled: this.props.tooltip && this.props.disabled,
            }),
        }), color = _a.color, children = _a.children, disabled = _a.disabled, href = _a.href, icon = _a.icon, iconPosition = _a.iconPosition, onClick = _a.onClick, outline = _a.outline, to = _a.to, tooltip = _a.tooltip, tooltipPlacement = _a.tooltipPlacement, otherProps = __rest(_a, ["color", "children", "disabled", "href", "icon", "iconPosition", "onClick", "outline", "to", "tooltip", "tooltipPlacement"]);
        return (React.createElement(React.Fragment, null,
            React.createElement(reactstrap_1.Button
            // Pass in an aria-disabled role on buttons with tooltips
            , __assign({ "aria-disabled": !tooltip ? undefined : disabled, 
                // If we have a color, use it. Otherwise, use "primary".
                color: color !== null && color !== void 0 ? color : "primary", 
                // Only pass in the disabled prop if we don't have a tooltip
                disabled: tooltip ? undefined : disabled, 
                // If we have an outline, use that. Otherwise, default is outline if no color passed.
                outline: outline !== null && outline !== void 0 ? outline : !color, innerRef: this.buttonRef, 
                // Pass a null-returning onclick if we're disabled. Prevents onClick on fake-disabled buttons.
                // NOTE: without an onClick, Reactstrap's Button doesn't set a type="button", which breaks
                // a bunch of snapshots. Hence the weird gymnastics here.
                onClick: disabled ? function () { return null; } : onClick, tag: to ? react_router_dom_1.Link : href ? "a" : undefined, href: href, to: to }, otherProps),
                icon && iconPosition !== "after" && React.createElement(components_1.GKIcon, { name: icon }),
                children,
                icon && iconPosition === "after" && React.createElement(components_1.GKIcon, { name: icon })),
            tooltip && (React.createElement(components_1.GKTooltip, { target: this.buttonRef, placement: tooltipPlacement }, tooltip))));
    };
    return GKButton;
}(common_1.GKPureComponent));
exports.GKButton = GKButton;
